(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
/**
 * Track viewed product handles in localStorage
 */
(function() {
  var sectionEl = document.querySelector('.recently-viewed-products');
  if (!sectionEl) return;

  var productHandle = sectionEl.dataset.currentHandle || null;
  var maxItems = 12;
  var storageKey = 'recentlyviewed';

  if (productHandle) {
    var viewed = JSON.parse(localStorage.getItem(storageKey) || '[]');
    viewed = viewed.filter(function(h) { return h !== productHandle });
    viewed.unshift(productHandle);
    if (viewed.length > maxItems) viewed = viewed.slice(0, maxItems);
    localStorage.setItem(storageKey, JSON.stringify(viewed));
  }
})();

/**
 * Load recently viewed products into section
 */



// document.addEventListener('DOMContentLoaded', loadRecentlyViewedIntoSection);
// document.addEventListener("shopify:section:load", function(event) {
//   if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].recently-viewed-products')) {
//     loadRecentlyViewedIntoSection();
//   }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
